import {
    faBell,
    faBullhorn,
    faCalendar,
    faCircleInfo,
    faGlobe,
    faMoneyBill,
    faTriangleExclamation,
    faUser,
} from "@fortawesome/pro-regular-svg-icons";
import type { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import type { AnnouncementIcon } from "@dashboard/api/task";

interface AnnouncementIconEntry {
    icon: IconDefinition;
    labelKey: string;
}

export const announcementIconMap: Record<AnnouncementIcon, AnnouncementIconEntry> = {
    ANNOUNCEMENT: { icon: faBullhorn, labelKey: "announcement.icon.announcement" },
    CALENDAR: { icon: faCalendar, labelKey: "announcement.icon.calendar" },
    PEOPLE: { icon: faUser, labelKey: "announcement.icon.person" },
    ALERT: { icon: faTriangleExclamation, labelKey: "announcement.icon.alert" },
    BELL: { icon: faBell, labelKey: "announcement.icon.notification" },
    SALARY: { icon: faMoneyBill, labelKey: "announcement.icon.salary" },
    GLOBAL: { icon: faGlobe, labelKey: "announcement.icon.global" },
    INFO: { icon: faCircleInfo, labelKey: "announcement.icon.info" },
};

export const announcementIconKeys = Object.keys(announcementIconMap) as AnnouncementIcon[];
